/** @typedef {import('./types').FlightSeoRouteCategory} FlightSeoRouteCategory */

/** Base URL for canonical links — matches PageHelmet / SEO_DEFAULTS.baseUrl. */
export const FLIGHT_SEO_BASE_URL = 'https://www.yovotrip.com';

/** SEO route path prefix — canonical and related-route URLs. */
export const FLIGHT_SEO_PATH_PREFIX = '/flights';

/** Default market for Phase 1 domestic routes. */
export const FLIGHT_SEO_DEFAULT_MARKET = 'domestic-IN';

/** Maximum FAQs rendered on a landing page. */
export const FLIGHT_SEO_MAX_FAQS = 15;

/** Maximum related routes per auto-generated block. */
export const FLIGHT_SEO_MAX_RELATED_ROUTES = 6;

/**
 * Slug format: `{origin}-to-{destination}` with lowercase alphanumeric segments.
 * @type {RegExp}
 */
export const FLIGHT_SEO_SLUG_PATTERN =
  /^[a-z0-9]+(-[a-z0-9]+)*-to-[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Category-level defaults used when a route has no structured override.
 * @type {Record<string, import('./types').FlightSeoRouteStructuredDefaults>}
 */
export const FLIGHT_SEO_CATEGORY_DEFAULTS = {
  'metro-metro': {
    typicalDurationMinutes: 150,
    typicalDistanceKm: 1200,
    dailyFlightsEstimate: '30+',
    popularAirlines: ['6E', 'AI', 'SG', 'QP'],
    startingFareLabel: '₹3,600 onwards',
  },
  'metro-tier2': {
    typicalDurationMinutes: 120,
    typicalDistanceKm: 900,
    dailyFlightsEstimate: '10+',
    popularAirlines: ['6E', 'AI', 'SG'],
    startingFareLabel: '₹3,200 onwards',
  },
  'tier2-tier2': {
    typicalDurationMinutes: 105,
    typicalDistanceKm: 700,
    dailyFlightsEstimate: '5+',
    popularAirlines: ['6E', 'AI'],
    startingFareLabel: '₹3,000 onwards',
  },
  leisure: {
    typicalDurationMinutes: 135,
    typicalDistanceKm: 1000,
    dailyFlightsEstimate: '15+',
    popularAirlines: ['6E', 'AI', 'SG', 'IX'],
    startingFareLabel: '₹3,200 onwards',
  },
  business: {
    typicalDurationMinutes: 120,
    typicalDistanceKm: 850,
    dailyFlightsEstimate: '20+',
    popularAirlines: ['6E', 'AI', 'QP', 'SG'],
    startingFareLabel: '₹3,800 onwards',
  },
};

/**
 * Default booking tip IDs per category (resolved from shared/booking-tips.json).
 * @type {Record<FlightSeoRouteCategory, string[]>}
 */
export const FLIGHT_SEO_CATEGORY_BOOKING_TIP_IDS = {
  'metro-metro': ['book-early-metro', 'compare-fares-weekly', 'morning-departure-value'],
  'metro-tier2': ['book-early-metro', 'compare-fares-weekly', 'check-nearby-airports'],
  'tier2-tier2': ['compare-fares-weekly', 'flexible-dates-save'],
  leisure: ['book-early-leisure', 'flexible-dates-save', 'weekday-travel-tip'],
  business: ['book-early-metro', 'morning-departure-value', 'compare-fares-weekly'],
};

/** Default baggage content ID for domestic economy. */
export const FLIGHT_SEO_DEFAULT_BAGGAGE_ID = 'domestic-economy-default';
